import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { USER_PROFILE_QUERY_KEY } from '@/core/constants/query-keys';
import useAuthSession, {
  readHasAuthSessionFromBrowser,
} from '@/core/hooks/use-auth-session';
import { getUserProfile } from '@/core/services/fetchers';
import composeLocale from '@/core/utils/locale/compose-locale';
import { setProfilePreferredLocaleCookie } from '@/core/utils/locale/logged-in-locale-cookies';

const useUserProfile = () => {
  const hasAuthSession = useAuthSession();

  const query = useQuery({
    queryKey: [USER_PROFILE_QUERY_KEY],
    queryFn: () => getUserProfile(),
    enabled: hasAuthSession || readHasAuthSessionFromBrowser(),
  });

  useEffect(() => {
    const profileLocale = composeLocale(
      query.data?.personalData.preferredLanguage,
      query.data?.personalData.preferredCountry,
    );
    if (!profileLocale) return;
    setProfilePreferredLocaleCookie(profileLocale);
  }, [query.data]);

  return query;
};

export default useUserProfile;
